import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { LoginService } from './services/login.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router,
    private authService: LoginService) { }


  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    const user = this.authService.getUser();

    const publicRoutes = ['/login', '/register', '/forgot-password', '/register-password', '/reset-password' , '/fines' , '/confirm-payment-fines'];
    const notAdminRoutes = ['/payments'];
    const currentRoute = state.url.toLowerCase();
    
    if (!user) {
      if (publicRoutes.includes(currentRoute)) {
        return true;
      }
      this.router.navigateByUrl('/login');
      return false;
    }
      if (currentRoute.includes('fines') || currentRoute.includes('confirm-payment-fines')) {
      return true;
    }
    if (publicRoutes.includes(currentRoute)) {
      this.router.navigateByUrl('/app-list');
      return false;
    }
    if(this.authService.isAdmin()){
       if (notAdminRoutes.includes(currentRoute)) {
      this.router.navigateByUrl('/app-list');
      return false;
    }
    }
    return true;
  }

}